export const TIMMER = 'TIMMER';
